export const TIMMER = 'TIMMER';
